<span class="badge badge-config-pedido-tipo-venda badge-config-pedido-tipo-venda-remessa"
    [title]="isAbreviacao ? tipo.nome : ''">
    {{isAbreviacao ? tipo.abreviacao : tipo.nome}}
</span>